import { Sigilo } from "../../styled";

const CustomSigilo = ({ sigilo }: { sigilo: string }) => {
  return <Sigilo></Sigilo>;
};

export default CustomSigilo;
